import { Injectable, signal, computed } from '@angular/core';

/**
 * Global loading service for API requests.
 * Uses a request counter so concurrent requests don't prematurely hide the loader.
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly _count = signal(0);

  /** True whenever at least one tracked API request is in-flight */
  readonly isLoading = computed(() => this._count() > 0);

  show(_message?: string): void {
    this._count.update((n) => n + 1);
  }

  hide(): void {
    this._count.update((n) => Math.max(0, n - 1));
  }
}
